<mat-card>
  <mat-spinner *ngIf="showSpinner" color='primary' diameter="80" strokeWidth="4"></mat-spinner>
  <iframe (load)="loadSuccess()" *ngIf="url" [src]="url | safe: 'resourceUrl'" allowtransparency
          data-hj-allow-iframe frameborder="0"
          onload="iFrameResize({checkOrigin:false, autoResize: true}, this)" style="background: #FFFFFF;">
  </iframe>
</mat-card>
